// @ts-strict-ignore
import { PageWrapper } from "@aviary/layouts";
import { DefaultStaticData } from "@clinic/shared/context/StaticDataContext";
import { CookieBanner } from "@emerson/components/CookieBanner/CookieBanner";
import { EmersonFavicon } from "@emerson/components/EmersonFavicon/EmersonFavicon";
import { Providers } from "@emerson/components/Providers/Providers";
import { EmersonTitle } from "@shared/components/EmersonTitle/EmersonTitle";
import { useLocation, ScrollRestoration, Outlet } from "@shared/react-router-dom/react-router-dom";

import { Footer } from "./Footer/Footer";
import { Header } from "./Header/Header";

import * as styles from "./Root.styles";

interface Props {
  roleId: string;
  userId: string;
  storeId: string;
  adminImpersonating: boolean;
  taxComplianceEmail?: string;
}

const Root = ({ roleId, userId, storeId, adminImpersonating, taxComplianceEmail }: Props) => {
  return (
    <Providers
      roleId={roleId}
      userId={userId}
      storeId={storeId}
      staticData={{
        ...DefaultStaticData,
        taxComplianceEmail,
        adminImpersonating,
        fsWholesaleEnabled: true,
      }}
    >
      <EmersonFavicon />
      <EmersonTitle />
      <Layout />
    </Providers>
  );
};

const Layout = () => {
  const { pathname } = useLocation();
  const hiddenPaths = ["/welcome", "/update-migration-password"];
  const showLayout = !hiddenPaths.some(path => pathname.includes(path));

  if (!showLayout) {
    return <Outlet />;
  }

  return (
    <div css={styles.page}>
      <Header />
      <div css={styles.main}>
        <PageWrapper>
          <CookieBanner />
          <Outlet />
          <ScrollRestoration getKey={location => `${location.pathname}${location.search}`} />
        </PageWrapper>
      </div>
      <Footer />
    </div>
  );
};

export { Root };
